module.exports = __webpack_public_path__ + "img/eye.170b70d0.svg";